import { Injectable, signal, Type } from '@angular/core';

export type UiModalSize = 'sm' | 'md' | 'lg';

export interface UiDialogTextPayload {
  kind: 'text';
  title: string;
  message: string;
  size: UiModalSize;
  closable: boolean;
}

export interface UiDialogComponentPayload {
  kind: 'component';
  title: string;
  size: UiModalSize;
  closable: boolean;
  component: Type<unknown>;
  inputs?: Record<string, unknown>;
}

export type UiDialogPayload = UiDialogTextPayload | UiDialogComponentPayload;

@Injectable({ providedIn: 'root' })
export class DialogService {
  readonly state = signal<UiDialogPayload | null>(null);

  openAlert(options: {
    title: string;
    message: string;
    size?: UiModalSize;
    closable?: boolean;
  }): void {
    this.state.set({
      kind: 'text',
      title: options.title,
      message: options.message,
      size: options.size ?? 'md',
      closable: options.closable ?? true,
    });
  }

  openComponent(options: {
    title: string;
    component: Type<unknown>;
    inputs?: Record<string, unknown>;
    size?: UiModalSize;
    closable?: boolean;
  }): void {
    this.state.set({
      kind: 'component',
      title: options.title,
      component: options.component,
      inputs: options.inputs ?? {},
      size: options.size ?? 'md',
      closable: options.closable ?? true,
    });
  }

  close(): void {
    this.state.set(null);
  }
}
